export const config = {
  title: "Construction By Delagrange | Expert Construction Services | New Haven, IN",
  meta: {
    description:
      "Construction By Delagrange provides expert construction services in New Haven, IN. Over 7 years of experience in concrete foundations, decorative hardscaping, structures, and home additions.",
    keywords: [
      "Construction By Delagrange",
      "Construction Services New Haven",
      "Concrete Foundations Indiana",
      "Decorative Hardscaping",
      "Home Additions IN",
      "Pole Barns Indiana",
      "Licensed Contractors",
      "Concrete Contractors"
    ],
    author: "Construction By Delagrange",
    canonicalUrl: "https://constructionbydelagrangellc.com/",
  },
  sections: {
    header: {
      businessName: "Construction By Delagrange",
    },
    sectionB: {
      heroTitle: "Expert Craftsmanship in Concrete & Design",
      heroSubtitle: "Construction Solutions Built to Last in New Haven, IN",
      learnAboutText: "Get Your Free Estimate",
      phoneNumber: "2604465945",
      phoneLabel: "(260) 446-5945",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
      cardData: [
        {
          title: "Decorative & Hardscaping",
          description:
            "Create stunning outdoor living spaces with custom concrete and hardscaping designs built for beauty, durability, and long-lasting functionality.",
        },
        {
          title: "Concrete Foundations",
          description:
            "Expertly poured concrete foundations, slabs, and retaining walls engineered to support structures and withstand challenging environmental conditions.",
        },
        {
          title: "Structures & Additions",
          description:
            "Custom-built garages, pole barns, and seamless room additions tailored to fit your lifestyle or business needs.",
        },
      ],
      description:
        "For over 7 years, Construction By Delagrange has built a reputation for quality, reliability, and craftsmanship as a family-owned company in New Haven, IN.",
    },
    sectionC: {
      servicesTitle: "Comprehensive Construction Services",
      servicesDescription:
        "Licensed contractors committed to your vision, delivering dependable results backed by full licensing and insurance. We handle every step with care from design to finishing touches.",
      cards: [
        {
          title: "Concrete & Foundation Work",
          description:
            "Expert concrete foundations, slabs, retaining walls, decorative stamped concrete, and driveway tear-out and replacement services.",
          imageSrc: "https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Concrete Foundation Work",
        },
        {
          title: "Decorative Hardscaping",
          description:
            "Custom hardscaping designs, decorative concrete work, epoxy coatings, and outdoor living spaces that combine beauty with functionality.",
          imageSrc: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Decorative Hardscaping Services",
        },
        {
          title: "Structures & Buildings",
          description:
            "Custom garages, pole barns, home additions, wood fencing, and structural construction tailored to residential and commercial needs.",
          imageSrc: "https://media.istockphoto.com/id/1071758126/photo/new-complex-of-apartment-buildings-under-construction.jpg?s=612x612&w=0&k=20&c=aQMttMRfqGuMJi7vdr0y7j7ZLivafvuWN9rwv8v9m8g=",
          imageAlt: "Construction Structures",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Epoxy Coatings & Reseals",
        "Power Washing Services",
        "Shrub & Tree Services",
        "Wood Fencing Installation",
        "Project Management",
      ],
    },
    sectionD: {
      aboutTitle: "About Construction By Delagrange",
      aboutImage: {
        src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2076&auto=format&fit=crop&ixlib=rb-4.0.3",
        alt: "Construction By Delagrange Team",
      },
      aboutText: [
        "For over 7 years, Construction By Delagrange has built a reputation for quality, reliability, and craftsmanship. As a family-owned company, we believe every project is more than just construction—it's an opportunity to create something meaningful and lasting.",
        "Our team takes pride in offering construction services that combine creativity and precision, ensuring the final result is both functional and beautiful. We combine modern equipment with time-tested methods to achieve results that stand the test of time, enhancing your home or business with both durability and visual appeal.",
      ],
    },
    sectionE: {
      profileImage: "https://constructionbydelagrangellc.com/wp-content/uploads/logo.webp",
      profileAlt: "Construction By Delagrange",
      businessName: "Construction By Delagrange",
      contact: {
        phone: "2604465945",
        phoneLabel: "(260) 446-5945",
        email: "constructionbydelagrangellc@gmail.com",
        website: "https://constructionbydelagrangellc.com/",
        address: "New Haven, IN",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/p/Construction-By-Delagrange-61568894008096/",
      },
    },
    sectionF: {
      address: "New Haven, IN",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96558.123456789!2d-85.0173778!3d41.0745567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8815c8f1234567890a%3A0x1234567890abcdef!2sNew%20Haven%2C%20IN!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;